export default __webpack_public_path__ + "static/media/bonus1.ca984d99.webm";